import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSuperbillTasks = asyncThunkWrapper({ 
  model: 'superbillTasks', 
  action: 'getSuperbillTasks', 
  func: async ({ id, offset = 0 }) => {
    const attributes = [
      'id', 
      { superbill_goal: ['id', { clinician: ['id', 'first_name', 'last_name'] }, 'email'] }, 
      { result: ['id', 'filename'] }, 
      'status', 
      'updated_at'
    ];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get(`/superbill_analyses/${id}/superbill_tasks`, { params });

    return response.data;
  } 
});
export const getSuperbillTask = asyncThunkWrapper({ 
  model: 'superbillTasks', 
  action: 'getSuperbillTask', 
  func: async (id) => {
    const attributes = [
      'id', 
      { superbill_goal: ['id', { clinician: ['id', 'first_name', 'last_name'] }, 'email'] }, 
      { result: ['id', 'filename', 'content_type', 'url'] },
      'status', 
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/superbill_tasks/${id}`, { params });

    return response.data;
  } 
});
export const clearLocalSuperbillTasks = createAction('superbillTasks/clearLocalSuperbillTasks');
export const clearLocalActiveSuperbillTask = createAction('superbillTasks/clearLocalActiveSuperbillTask');